import {createSvgIcon} from '@ui/icons/create-svg-icon';

export const ArrowOutwardIcon = createSvgIcon(
  <path d="m256-240-56-56 384-384H240v-80h480v480h-80v-344L256-240Z" />,
  'ArrowOutwardIcon',
  '0 -960 960 960',
);
